export default __webpack_public_path__ + "static/media/sparck-gift-rounded.cf2fb662.png";